module.exports = __webpack_public_path__ + "img/fashion_thumbnail-600x450.76bbda32.jpg";